import { Link } from "react-router-dom";

function WEFProgressBox({
  Attendee,
  WEFprogressData,
  allWEFComplete_NotDeclarations,
}) {
  return (
    <div className="progress-box" style={{ fontSize: "2vmin" }}>
      <div className="progress-container">
        {WEFprogressData.map((item, index) => (
          <div key={index} className="progress-item">
            <div className="progress-item-content">
              <span className="progress-text">
                <strong>{item.label}</strong>
              </span>
            </div>
            <div className="progress-bar">
              <div
                className={`progress-bar-fill ${
                  Attendee &&
                  Attendee.SEFProgress &&
                  Attendee.SEFProgress[item.Prop]
                    ? //
                      Attendee.SEFProgress[item.Prop] === "Complete"
                      ? "Complete"
                      : Attendee.SEFProgress[item.Prop] === "In_Progress"
                      ? "In_Progress"
                      : Attendee.SEFProgress[item.Prop] === "Awaiting Review"
                      ? "Awaiting_Review"
                      : "Incomplete"
                    : //
                      "Incomplete"
                }`}
              >
                <span
                  className={`progress-bar-text ${
                    Attendee &&
                    Attendee.SEFProgress &&
                    Attendee.SEFProgress[item.Prop]
                      ? //
                        Attendee.SEFProgress[item.Prop] === "Complete"
                        ? "Complete"
                        : Attendee.SEFProgress[item.Prop] === "In_Progress"
                        ? "In_Progress"
                        : Attendee.SEFProgress[item.Prop] === "Awaiting Review"
                        ? "Awaiting_Review"
                        : "Incomplete"
                      : //
                        "Incomplete"
                  }`}
                >
                  {Attendee && Attendee._id && Attendee._id.length > 0
                    ? //
                      Attendee.SEFProgress && Attendee.SEFProgress[item.Prop]
                      ? //
                        Attendee.SEFProgress[item.Prop] === "Complete"
                        ? "Complete"
                        : Attendee.SEFProgress[item.Prop] === "In_Progress"
                        ? "In Progress"
                        : Attendee.SEFProgress[item.Prop] === "Incomplete"
                        ? "Incomplete"
                        : Attendee.SEFProgress[item.Prop] === "Awaiting Review"
                        ? "Awaiting Review"
                        : "Incomplete"
                      : //
                        "Incomplete"
                    : //
                      "Loading..."}
                </span>
              </div>
            </div>
            <Link
              to={`/Student/${item.link}/${
                Attendee._id && Attendee._id.length > 0 ? Attendee._id : ""
              }`}
              style={{
                textDecoration: "none",
                color: "inherit",
                width: "20%",
                marginRight: "10px",
              }}
              target="_blank"
            >
              <button
                className={`go-to-button ${
                  Attendee && Attendee._id && Attendee._id.length > 0
                    ? //
                      Attendee.SEFProgress && Attendee.SEFProgress[item.Prop]
                      ? //
                        Attendee.SEFProgress[item.Prop] === "Complete"
                        ? "Complete"
                        : Attendee.SEFProgress[item.Prop] === "In Progress"
                        ? "In Progress"
                        : Attendee.SEFProgress[item.Prop] === "Incomplete"
                        ? "Incomplete"
                        : Attendee.SEFProgress[item.Prop] === "Awaiting Review"
                        ? "Awaiting Review"
                        : "Incomplete"
                      : //
                        "Incomplete"
                    : //
                      "Loading..."
                }`}
                disabled={
                  !allWEFComplete_NotDeclarations() &&
                  item.label === "Declarations"
                    ? true
                    : false
                }
                style={{
                  fontSize: "1.2em",
                  backgroundColor:
                    !allWEFComplete_NotDeclarations() &&
                    item.label === "Declarations"
                      ? "lightgrey"
                      : "",
                }}
              >
                Go to
              </button>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default WEFProgressBox;
